var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnChapter = function SvgBtnChapter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 10.333V2.667m0 7.666L6 7.56m2.333 2.773 2.333-2.773",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 12v.667C2.667 13.403 3.264 14 4 14h8.667c.736 0 1.333-.597 1.333-1.333V12",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgBtnChapter;